import PropTypes from 'prop-types';
import * as React from 'react';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import { useTheme } from '@mui/material/styles';
import {
  useMediaQuery,
  Box,
  Button,
  Chip,
  Container,
  Drawer,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Toolbar,
  Typography,
  useScrollTrigger
} from '@mui/material';

import IconButton from '../../Components/@extended/IconButton';
import AnimateButton from '../../Components/@extended/AnimateButton';

import {MenuOutlined, LineOutlined, LoginOutlined} from '@ant-design/icons';
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import {Auth} from "aws-amplify";

function ElevationScroll({ layout, children, window }) {
  const theme = useTheme();
  // const theme = useTheme();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 10,
    target: window ? window() : undefined
  });

  const backColorScroll = '#343434';
  const backColor = 'transparent';

  return React.cloneElement(children, {
    style: {
      backgroundColor: trigger ? backColorScroll : backColor
    }
  });
}

function LoginButton(){
    console.log("Going to login")
    return (
        <>
            <AnimateButton>
                <Button size="large"
                        onClick={() => Auth.federatedSignIn()}
                        endIcon={<LoginOutlined />}
                        variant="contained"
                >Sign in
                </Button>
            </AnimateButton>
        </>
    )
}

const Header = ({ layout = 'landing', ...others }) => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  return (
      <Navbar bg="dark" variant="dark">
                    <Container>
                      <Navbar.Brand href="/">Ikigai</Navbar.Brand>
                    </Container>
          <Nav className="justify-content-end">
              <Nav.Link href="/getting-started">Get Started</Nav.Link>
              {/*<Nav.Link href="/faq">FAQ</Nav.Link>*/}
                            <LoginButton />

                        </Nav>
                  </Navbar>
      // <ElevationScroll layout={layout} {...others}>
      //   <AppBar sx={{ bgcolor: 'transparent', color: theme.palette.text.primary, boxShadow: 'none' }}>
      //       <Container disableGutters={matchDownMd}>
      //         <Toolbar sx={{ px: { xs: 1.5, md: 0, lg: 0 }, py: 2 }}>
      //           <Stack direction="row" sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} alignItems="center">
      //               {/*{layout !== 'landing' && (*/}
      //               <Navbar style={{background:"#343434FF"}}>
      //               <Container>
      //                 <Navbar.Brand href="/" style={{color:"white"}}>Ikigai</Navbar.Brand>
      //                   <Nav className="justify-content-end">
      //                       <LoginButton />
      //                   </Nav>
      //
      //
      //               </Container>
      //             </Navbar>
      //                   {/*)}*/}
      //           </Stack>
      //         </Toolbar>
      //       </Container>
      //   </AppBar>
      //
      // </ElevationScroll>
  )
}

Header.propTypes = {
  layout: PropTypes.string
};

export default Header;